{
  "error": "Error",
  "warning": "Warning",
  "info": "Information",
  "help": "Help",
  "success": "Success"
}
